import styled from '@emotion/styled'

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-shrink: 1;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const StatusContent = styled.div<{ fullWidth: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-shrink: 1;
  justify-content: center;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '40%')};
  height: 100%;
`

export const IllustrationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 279px;
`
